import React from 'react';
import DSPPricingList from './DSPPricingList';

interface DSPPricingPageProps {
    businessScenario: number | null;
}

/**
 * DSP定价主页面组件
 * 管理 DSP 定价的列表、创建、查看、编辑等视图切换
 */
const DSPPricingPage: React.FC<DSPPricingPageProps> = ({ businessScenario }) => {
    return (
        <div className="mb-6">
            <DSPPricingList businessScenario={businessScenario} />
        </div>
    );
};

export default DSPPricingPage;
